import { ReactNode } from "react";
import classNames from "clsx";

interface TriggerElementProps {
  label: string;
  isOpen?: boolean;
  additionalElements?: ReactNode;
}

export const TemplateFormAccordionTrigger = ({ label, isOpen, additionalElements }: TriggerElementProps) => {
  return (
    <div
      className={classNames(
        "flex",
        "h-12",
        "items-center",
        "justify-between",
        "py-3.5",
        "border-b",
        "border-border-action"
      )}
      data-testid="template-form-accordion-trigger-wrapper"
    >
      <div className="flex">
        <i
          className={classNames(
            `icon-lt-arrow-${isOpen ? "down" : "right"}-s-line`,
            "flex",
            "text-xl",
            "text-text-base-primary",
            "font-semibold",
            "px-2.5"
          )}
          data-testid="template-form-accordion-trigger-icon"
        />
        <span
          className={classNames("flex", "font-semibold", "text-sm", "leading-5", "text-text-base-primary")}
          data-testid="template-form-accordion-trigger-label"
        >
          {label}
        </span>
      </div>
      {additionalElements}
    </div>
  );
};
